export default __webpack_public_path__ + "static/media/female_breast-01.5e4a746d.png";